export const newsList = [
  {
    id: 'n1',
    title: '年度音乐盛典落幕，新生代歌手包揽五项大奖引热议',
    excerpt: '本届音乐盛典在掌声中收官，多位新生代歌手凭借高质量的现场表现拿下重磅奖项，社交平台讨论量当晚突破两亿。',
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20music%20awards%20stage%20with%20warm%20orange%20spotlights%2C%20glowing%20golden%20confetti%2C%20editorial%20entertainment%20photography%2C%20soft%20depth%20of%20field%2C%20elegant%20modern%20background&width=800&height=600&seq=news-cover-01&orientation=landscape',
    source: '星光娱乐',
    author: '林一',
    publishedAt: '2026-10-11',
    category: '娱乐新闻',
    tags: ['明星动态', '音乐盛典'],
    views: 128400,
    content: [
      '本届音乐盛典于昨晚圆满落幕，全场气氛从开场便一路走高。新生代歌手在舞台上的稳定发挥成为最大看点，多个现场片段迅速登上热搜榜单。',
      '评审团在颁奖后表示，今年的作品在旋律设计与现场编排上都有明显突破，年轻创作者正在把流行音乐的表达方式推向更多元的方向。',
      '据主办方统计，盛典相关话题的社交平台讨论量在当晚突破两亿次，多个舞台片段在短视频平台的播放量持续攀升。',
    ],
    quote: { text: '音乐的力量在于它总能第一时间抵达人心，我们只是把这份热爱搬上更大的舞台。', source: '盛典评审团致辞' },
  },
  {
    id: 'n2',
    title: '都市悬疑剧《雾城谜影》口碑走高，连续三周登顶热度榜',
    excerpt: '这部以节奏与细节取胜的都市悬疑剧，用克制的叙事赢得观众，豆瓣讨论区连日刷新评论量。',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20urban%20night%20cityscape%20with%20warm%20streetlight%20glow%2C%20fog%20and%20neon%20reflections%2C%20cinematic%20editorial%20photography%2C%20soft%20contrast%2C%20clean%20modern%20background&width=800&height=600&seq=news-cover-02&orientation=landscape',
    source: '剧集观察',
    author: '苏晓',
    publishedAt: '2026-10-10',
    category: '影视动态',
    tags: ['影评解读', '电视剧'],
    views: 96200,
    content: [
      '《雾城谜影》播出过半，凭借紧凑的节奏和扎实的表演持续占据热度榜首位。剧集并没有依赖强反转，而是把线索藏在生活化的细节里。',
      '不少观众认为，该剧真正的看点在于人物关系的层层推进，每一集都会留下新的疑问，也会解答上一集埋下的伏笔。',
      '制作方透露，后续单元将逐步揭开主线谜题，并引入两条新的支线人物，节奏会进一步加快。',
    ],
  },
  {
    id: 'n3',
    title: '综艺《星厨来客》开播即爆，素人厨艺对决成新看点',
    excerpt: '这档把镜头交给普通人厨房的节目，用真实与烟火气打动观众，首期播放量刷新频道纪录。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20kitchen%20cooking%20scene%20with%20golden%20light%2C%20fresh%20ingredients%20and%20steam%2C%20editorial%20lifestyle%20photography%2C%20soft%20natural%20shadows%2C%20clean%20warm%20background&width=800&height=600&seq=news-cover-03&orientation=landscape',
    source: '综艺频道',
    author: '陈默',
    publishedAt: '2026-10-09',
    category: '综艺',
    tags: ['综艺', '社交热点'],
    views: 77300,
    content: [
      '《星厨来客》首期播出后迅速走红，节目把镜头对准普通人的厨房，用一道道家常菜串起真实的人生故事。',
      '与常见的竞技综艺不同，这档节目弱化了淘汰的紧张感，更强调人与人之间的交流与温暖。',
      '有评论认为，节目的成功说明观众正在从追逐话题转向寻找共鸣，真实感成为内容竞争的新核心。',
    ],
  },
  {
    id: 'n4',
    title: '古装大制作《长安夜行》公布首支预告，质感获赞',
    excerpt: '长达两分钟的先导预告展示了恢弘的城市夜景与细腻的服装道具，被网友称为近年少见的高完成度制作。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20warm%20lantern%20glow%2C%20elegant%20palace%20architecture%2C%20cinematic%20epic%20photography%2C%20rich%20warm%20tones%2C%20clean%20modern%20background&width=800&height=600&seq=news-cover-04&orientation=landscape',
    source: '影视前线',
    author: '周航',
    publishedAt: '2026-10-08',
    category: '影视动态',
    tags: ['影视动态', '预告片'],
    views: 88900,
    content: [
      '古装大制作《长安夜行》发布首支预告片，两分钟的片段以夜景开场，用光影勾勒出繁华与暗流并存的古都。',
      '预告中大量使用的实景搭建与手工服装细节成为讨论焦点，不少网友表示从画面质感就能看出制作团队的用心。',
      '官方同时公布了主演阵容与主要角色关系，剧集预计于明年上线，更多物料将在近期陆续释出。',
    ],
  },
  {
    id: 'n5',
    title: '演员沈知远斩获国际电影节最佳男主角，感言真挚',
    excerpt: '凭借在文艺片中的克制表演，沈知远成为本届电影节最大惊喜，领奖时的发言让全场动容。',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20film%20festival%20red%20carpet%20scene%20with%20warm%20golden%20lighting%2C%20blurred%20crowd%20and%20spotlights%2C%20editorial%20portrait%20photography%2C%20soft%20bokeh%2C%20clean%20premium%20background&width=800&height=600&seq=news-cover-05&orientation=landscape',
    source: '电影世界',
    author: '李念',
    publishedAt: '2026-10-07',
    category: '影视动态',
    tags: ['明星动态', '国际电影节'],
    views: 105600,
    content: [
      '在国际电影节的颁奖礼上，演员沈知远凭借一部文艺片中的细腻表演获得最佳男主角，成为当晚最受关注的名字之一。',
      '影评人认为，他的表演几乎没有夸张的情绪外露，却把角色内心的挣扎表现得层层递进，是典型的克制式演技。',
      '沈知远在领奖时表示，奖项属于整个团队，感谢每一个在片场默默付出的工作人员。',
    ],
  },
  {
    id: 'n6',
    title: '科幻新片《引力边境》定档，概念海报曝光引发猜想',
    excerpt: '片方发布的定档海报以巨大的行星与渺小的飞船构成强烈对比，网友围绕剧情展开热烈脑洞。',
    cover: 'https://readdy.ai/api/search-image?query=Deep%20space%20scene%20with%20a%20giant%20warm%20orange%20planet%20and%20a%20tiny%20spaceship%2C%20cinematic%20sci-fi%20concept%20art%2C%20soft%20glow%2C%20clean%20dramatic%20background&width=800&height=600&seq=news-cover-06&orientation=landscape',
    source: '科幻视界',
    author: '吴桐',
    publishedAt: '2026-10-06',
    category: '影视动态',
    tags: ['影视动态', '科幻'],
    views: 64100,
    content: [
      '科幻新片《引力边境》正式宣布定档，并发布了首张概念海报。海报中一颗巨大的行星占据了画面大部分，一艘渺小的飞船在其边缘航行。',
      '制片方表示，影片希望探讨人类在浩瀚宇宙中的位置，以及面对未知时最真实的情感反应。',
      '随着定档信息公布，关于剧情走向的讨论迅速升温，多个平台的相关话题阅读量持续上涨。',
    ],
  },
  {
    id: 'n7',
    title: '女团新专辑首周销量破纪录，主打歌舞蹈挑战刷屏',
    excerpt: '主打歌上线后迅速席卷短视频平台，简洁有力的编舞让无数素人加入翻跳，形成现象级传播。',
    cover: 'https://readdy.ai/api/search-image?query=Energetic%20pop%20dance%20stage%20with%20warm%20orange%20and%20pink%20lights%2C%20confetti%20and%20motion%20blur%2C%20editorial%20concert%20photography%2C%20clean%20vibrant%20background&width=800&height=600&seq=news-cover-07&orientation=landscape',
    source: '乐动传媒',
    author: '许安',
    publishedAt: '2026-10-05',
    category: '娱乐新闻',
    tags: ['明星动态', '社交热点'],
    views: 149200,
    content: [
      '某人气女团的新专辑首周销量刷新纪录，主打歌上线不到三天便登上多个音乐平台的热度榜前列。',
      '歌曲简洁易学的编舞成为传播关键，短视频平台上的翻跳挑战短短几天就聚集了数十万条投稿。',
      '业内人士分析，作品的传播力不仅来自旋律本身，更来自它鼓励所有人参与的设计思路。',
    ],
  },
  {
    id: 'n8',
    title: '纪录片《山河之间》上线，用镜头记录普通人的坚持',
    excerpt: '这部走访多地的纪录片没有宏大叙事，却用一个个普通人的故事，让观众看见生活本身的重量。',
    cover: 'https://readdy.ai/api/search-image?query=Serene%20mountain%20landscape%20at%20golden%20hour%20with%20soft%20warm%20light%2C%20documentary%20style%20photography%2C%20minimal%20clean%20composition%2C%20calm%20editorial%20aesthetic&width=800&height=600&seq=news-cover-08&orientation=landscape',
    source: '纪录频道',
    author: '郑野',
    publishedAt: '2026-10-04',
    category: '影视动态',
    tags: ['纪录片', '影评解读'],
    views: 43800,
    content: [
      '纪录片《山河之间》正式上线，摄制组历时两年走访多地，记录下一群普通人日复一日的坚持。',
      '影片没有刻意煽情，也没有宏大的旁白，而是把镜头长久地停留在人物的日常动作里，让观众自行体会。',
      '不少观众表示，看完之后对“平凡”有了新的理解，也对身边的人多了一份温柔的注视。',
    ],
  },
  {
    id: 'n9',
    title: '跨年晚会阵容官宣，多位实力唱将同台引期待',
    excerpt: '官方公布的嘉宾名单横跨多个年代，既有资深歌手，也有人气新星，被网友称为“神仙阵容”。',
    cover: 'https://readdy.ai/api/search-image?query=Grand%20new%20year%20celebration%20stage%20with%20warm%20orange%20and%20gold%20lights%2C%20festive%20sparkle%2C%20editorial%20concert%20photography%2C%20clean%20elegant%20background&width=800&height=600&seq=news-cover-09&orientation=landscape',
    source: '星光娱乐',
    author: '林一',
    publishedAt: '2026-10-03',
    category: '娱乐新闻',
    tags: ['明星动态', '晚会'],
    views: 58300,
    content: [
      '跨年晚会的嘉宾阵容正式官宣，名单横跨多个年代，兼顾怀旧与流行，引发广泛讨论。',
      '主办方介绍，今年的舞台设计将围绕“时间”展开，用不同的篇章串联起几代人的共同记忆。',
      '随着阵容公布，关于节目单的猜测在社交平台上持续发酵，多个相关话题登上热榜。',
    ],
  },
  {
    id: 'n10',
    title: '经典IP重启版上线，情怀与创新能否兼得引讨论',
    excerpt: '时隔多年重启的经典IP推出全新剧集，既保留了熟悉元素，也加入不少现代化的叙事尝试。',
    cover: 'https://readdy.ai/api/search-image?query=Nostalgic%20retro%20cinema%20interior%20with%20warm%20orange%20glow%2C%20vintage%20film%20posters%2C%20editorial%20photography%2C%20soft%20grainy%20texture%2C%20clean%20warm%20background&width=800&height=600&seq=news-cover-10&orientation=landscape',
    source: '剧集观察',
    author: '苏晓',
    publishedAt: '2026-10-02',
    category: '影视动态',
    tags: ['影视动态', '影评解读'],
    views: 51900,
    content: [
      '经典IP重启版正式上线，新版在保留标志性元素的同时，对人物设定和世界观做了不小的调整。',
      '观众的评价呈现两极：有人认为创新值得鼓励，也有人希望看到更原汁原味的呈现。',
      '主创团队回应称，重启的意义在于让新一代观众也能理解这个故事，而对老观众则保留了足够多的致敬细节。',
    ],
  },
  {
    id: 'n11',
    title: '电影《晚风告白》上映首日票房亮眼，小成本逆袭',
    excerpt: '这部没有大明星加持的爱情片，凭借真诚的故事与细腻的情绪表达，在上映首日赢得观众好评。',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20evening%20city%20riverside%20with%20warm%20sunset%20glow%2C%20soft%20bokeh%20lights%2C%20cinematic%20editorial%20photography%2C%20warm%20cozy%20atmosphere%2C%20clean%20background&width=800&height=600&seq=news-cover-11&orientation=landscape',
    source: '电影世界',
    author: '李念',
    publishedAt: '2026-10-01',
    category: '影视动态',
    tags: ['影视动态', '爱情片'],
    views: 45200,
    content: [
      '小成本爱情片《晚风告白》上映首日表现超出预期，排片占比不高却收获了稳定的上座率。',
      '影片用平淡的生活场景讲述一段双向奔赴的感情，没有刻意的情节冲突，却让不少观众在结尾红了眼眶。',
      '有影评人指出，这类作品的成功说明观众对真诚叙事的耐心一直都在。',
    ],
  },
  {
    id: 'n12',
    title: '明星公益行动持续升温，多组艺人加入环保倡议',
    excerpt: '多位艺人参与的城市环保倡议近日展开，用线下行动与线上传播带动公众关注绿色生活。',
    cover: 'https://readdy.ai/api/search-image?query=Green%20outdoor%20urban%20park%20with%20warm%20sunlight%2C%20people%20planting%20trees%2C%20documentary%20lifestyle%20photography%2C%20fresh%20clean%20composition%2C%20warm%20natural%20tones&width=800&height=600&seq=news-cover-12&orientation=landscape',
    source: '公益在线',
    author: '赵岚',
    publishedAt: '2026-09-30',
    category: '娱乐新闻',
    tags: ['社交热点', '公益'],
    views: 38700,
    content: [
      '由多位艺人共同参与的城市环保倡议近日启动，活动涵盖社区绿化、旧物回收等多个环节。',
      '参与者表示，希望借助自身影响力，让环保不再只是一句口号，而是可以随手完成的小事。',
      '倡议上线后获得大量网友响应，相关话题的参与人数持续增长。',
    ],
  },
  {
    id: 'n13',
    title: '综艺《我们的乐队》第二季回归，乐队文化再受关注',
    excerpt: '节目第二季在赛制上做出调整，强调乐队之间的协作与共创，为观众呈现更多元的音乐现场。',
    cover: 'https://readdy.ai/api/search-image?query=Live%20band%20performing%20on%20stage%20with%20warm%20orange%20lights%2C%20guitars%20and%20drums%2C%20editorial%20concert%20photography%2C%20energetic%20atmosphere%2C%20clean%20modern%20background&width=800&height=600&seq=news-cover-13&orientation=landscape',
    source: '综艺频道',
    author: '陈默',
    publishedAt: '2026-09-29',
    category: '综艺',
    tags: ['综艺', '音乐'],
    views: 47400,
    content: [
      '综艺《我们的乐队》第二季正式回归，首期节目便以高完成度的现场演出赢得关注。',
      '本季赛制更强调乐队成员之间的协作，鼓励不同风格的乐手组队共创，碰撞出更多可能。',
      '业内认为，节目让更多优秀的独立音乐人走到台前，也让乐队文化获得更广泛的关注。',
    ],
  },
  {
    id: 'n14',
    title: '短剧市场持续升温，精品化成为行业关键词',
    excerpt: '随着观众要求的提高，短剧创作正从追求数量转向打磨质量，精品化成为从业者的共识。',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20content%20creation%20studio%20with%20warm%20orange%20accent%20lighting%2C%20cameras%20and%20monitors%2C%20editorial%20photography%2C%20clean%20minimal%20background&width=800&height=600&seq=news-cover-14&orientation=landscape',
    source: '行业观察',
    author: '孙越',
    publishedAt: '2026-09-28',
    category: '娱乐新闻',
    tags: ['行业观察', '短剧'],
    views: 35600,
    content: [
      '短剧市场在过去一年持续升温，产量快速增长的背后，创作者开始把更多精力放在品质打磨上。',
      '多位从业者表示，观众的审美正在快速提升，只有扎实的剧本和用心的制作才能留住注意力。',
      '平台方也在调整推荐机制，鼓励更注重内容本身的作品获得更多曝光机会。',
    ],
  },
];